export const UPDATE_FEATURES = 'UPDATE_FEATURES'
export const UPDATE_FEATURES_FAILURE = 'UPDATE_FEATURES_FAILURE'

export const EVIDENTLY_PROJECT = 'red-app'

export interface Feature {
  entityId: string
  value: {
    [key in FeatureValueType]: boolean
  }
  variation: string
  name: string
}

export interface FeaturesResponse {
  features: Feature[]
}

export interface FeaturesState {
  features: Feature[]
  errorMessage: string
  isLoading: boolean
}

export enum FeatureValueType {
  BOOLEAN_VALUE = 'boolValue',
}

export interface FeaturesRequest {
  projectId: string
  sessionId: string
}
